<nk-spinner *ngIf="loadingSuccess"></nk-spinner>
<form [formGroup]="formGroup" (ngSubmit)="onNext()" *ngIf="!loadingSuccess">
  <div [innerHtml]="termsOfService.content" *ngIf="termsOfService"></div>
  <hr />
  <div [innerHtml]="privacyPolicy.content" *ngIf="privacyPolicy"></div>

  <div class="form-group my-3 form-success-highlight mt-4" [class.form-error-highlight]="showErrors">
    <label class="label pb-1" for="tos_agreed"> {{ 'sign_up.tos_privacy.terms_of_service' | translate }}*</label><br />
    <input type="checkbox" formControlName="tos_agreed" class="me-2" required id="tos_agreed" />
    <label for="tos_agreed">{{ 'sign_up.tos_privacy.i_agree_to_tos' | translate }}</label>

    <span class="warning" *ngIf="showErrors && formGroup.controls['tos_agreed'].errors?.required"
      ><br />{{ 'sign_up.tos_privacy.you_have_to_agree_tos' | translate }}</span
    >
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label class="label pb-1" for="privacy_agreed">{{ 'sign_up.tos_privacy.privacy_policy' | translate }}*</label><br />
    <input type="checkbox" formControlName="privacy_agreed" class="me-2" id="privacy_agreed" />
    <label for="privacy_agreed">{{ 'sign_up.tos_privacy.i_agree_to_privacy' | translate }}</label>
    <span class="warning" *ngIf="showErrors && formGroup.controls['privacy_agreed'].errors?.required">{{
      'sign_up.tos_privacy.you_have_to_agree_privacy' | translate
    }}</span>
  </div>

  <div class="text-muted mt-2"><br />{{ 'sign_up.tos_privacy.you_have_to_agree_tos_and_privacy' | translate }}</div>
  <br />

  <div class="error" *ngIf="earlierStepError">
    <p>
      {{ 'sign_up.tos_privacy.previous_step_error' | translate }}
    </p>
  </div>
  <div class="text-center">
    <button
      type="submit"
      size="lg"
      [ghost]="formGroup.status !== 'VALID'"
      nkButton
      color="success"
      [disabled]="loadingSuccess">
      {{ 'sign_up.tos_privacy.create_account_btn' | translate }}
    </button>
  </div>
</form>
